<ng-container *transloco="let t">
  <div id="login-bg"></div>
  <mat-card>
    <mat-card-header class="center">
      <mat-card-title> {{ title }} </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <button mat-flat-button type="submit" (click)="login()">
        <span class="text-white">{{ t('auth.signIn') }}</span>
      </button>
    </mat-card-content>
  </mat-card>
</ng-container>
